import React from 'react';

const ChartsHeader = () => {
  return <div className='dark:text-gray-200 mb-2'>ChartsHeader</div>;
};

export default ChartsHeader;
